import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import {
  DisconnectionNotification,
  DisconnectionNotificationForm,
} from './types';

export const disconnectionNotificationApi = createApi({
  reducerPath: 'disconnectionNotificationApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/disconnection-notifications',
  }),
  tagTypes: ['DisconnectionNotification', 'DisconnectionNotifications'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getDisconnectionNotificationById: builder.query<
      DisconnectionNotification,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `/${id}`,
      }),
      providesTags: () => ['DisconnectionNotifications'],
    }),
    createDisconnectionNotification: builder.mutation<
      string,
      DisconnectionNotificationForm
    >({
      query: data => ({
        url: '/',
        method: 'POST',
        data,
      }),
      invalidatesTags: id => [
        'DisconnectionNotifications',
        { type: 'DisconnectionNotification', id },
      ],
    }),
    updateDisconnectionNotification: builder.mutation<
      DisconnectionNotification,
      DisconnectionNotificationForm
    >({
      query: data => ({
        url: `/${data.id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: result => [
        'DisconnectionNotifications',
        { type: 'DisconnectionNotification', id: result?.id },
      ],
    }),
  }),
});

export const {
  useGetDisconnectionNotificationByIdQuery,
  useCreateDisconnectionNotificationMutation,
  useUpdateDisconnectionNotificationMutation,
} = disconnectionNotificationApi;
